import { NgModule } from '@angular/core';
import { FormatTimePipe } from './pipes/timeFormat.pipe';
import { ObjToArrPipe } from './pipes/objtoArr.pipe';
import { CoTimePipe } from './pipes/coTime.pipe';
import { StringFilterPipe } from './pipes/stringFilter.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { EqualValidatorDirective } from './directives/equal-validator.directive';
import { GroupFilterPipe } from './pipes/group-filter.pipe';
// ngx-translate Imports
import { TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ConfirmDialogClickDirective, TxConfirmDialogComponent } from './directives/confirm-dialog-click.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MomentPipe } from './pipes/moment.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { MaskedInputDirective } from './directives/masked-input.directive';
import { ArrayPipe } from './pipes/array.pipe';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import { StopClickPropagationDirective } from './directives/stop-click-propagation.directive';
import { ZeroFillPipe } from './pipes/zeroFill.pipe';
import { TranslateOrTextPipe } from './pipes/translateOrText.pipe';
import { TeamMembersPipe } from './pipes/teamMembers.pipe';
import { GlobalConstants } from '../globalConstants';

// AoT requires an exported function for factories.
// Cache-Bust: der App-Version-Querystring sorgt dafür, dass der Browser nach
// jedem Release die i18n-Dateien neu lädt (neue Übersetzungs-Keys erscheinen
// sofort, ohne dass der Nutzer den Cache leeren muss).
export function HttpLoaderFactory(httpClient: HttpClient) {
	return new TranslateHttpLoader(httpClient, 'assets/i18n/', `.json?v=${GlobalConstants.appVersion}`);
}

FullCalendarModule.registerPlugins([
	// register FullCalendar plugins
	dayGridPlugin,
	timeGridPlugin,
	interactionPlugin,
	momentPlugin,
	bootstrapPlugin,
]);

@NgModule({
	imports: [
		NgxPaginationModule,
		ZXingScannerModule,
		FullCalendarModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		MatDialogModule,
		MatButtonModule,
	],
	declarations: [
		FormatTimePipe,
		FilterPipe,
		MomentPipe,
		ArrayPipe,
		SortPipe,
		ObjToArrPipe,
		CoTimePipe,
		StringFilterPipe,
		EqualValidatorDirective,
		GroupFilterPipe,
        ZeroFillPipe,
		TranslateOrTextPipe,
		TeamMembersPipe,
		ConfirmDialogClickDirective,
		TxConfirmDialogComponent,
		MaskedInputDirective,
		StopClickPropagationDirective,
	],
	providers: [TranslatePipe],
	exports: [
		FormatTimePipe,
		FilterPipe,
		MomentPipe,
		SortPipe,
		ObjToArrPipe,
		CoTimePipe,
		StringFilterPipe,
		GroupFilterPipe,
        ZeroFillPipe,
		TranslateOrTextPipe,
		TeamMembersPipe,
		NgxPaginationModule,
		ZXingScannerModule,
		TranslateModule,
		FullCalendarModule,
		ConfirmDialogClickDirective,
		TxConfirmDialogComponent,
		MomentPipe,
		ArrayPipe,
		MaskedInputDirective,
		StopClickPropagationDirective,
		EqualValidatorDirective,
	],
})
export class TxSharedModule {}
